exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "._wrapper {\n  -ms-flex: 1 1 auto;\n      flex: 1 1 auto;\n}\n", ""]);

// exports
